<div class="verify-email-container">
  <achoo-placeholder [placeholderId]="'verifyEmailHolder'" [normalPlaceholder]="true" [isFullscreenLoader]="true">
    <div *ngIf="!isVerifying">
      <p class="text-center app-logo"><img src="{{ 'APP.LOGO' | translate }}" width="300" alt="logo"/></p>
      <p class="text-center text-content">{{verifyMessage}}</p>
      <div class="d-flex justify-content-center align-items-center">
        <button class="btn btn-default login-btn"
                type="button"
                (click)="afterVerify()">{{verifyButton}}</button>
      </div>
    </div>
  </achoo-placeholder>
</div>



// WEBPACK FOOTER //
// ./src/app/auth/verify-new-account/verify-new-account.component.html